/**
 * import {class} from './modules/{filename}'
 */

/**
 * To add jQuery support for $
 *
 */

var $ = require("jquery");

function initLenis() {
	document.querySelectorAll(".sub-menu").forEach(function (menu) {
		menu.setAttribute("data-lenis-prevent", "");
	});

	const lenis = new Lenis({
		duration: 1.2, // Adjust duration for smooth scroll speed
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Easing function for smooth scrolling
	});

	lenis.on("scroll", ScrollTrigger.update);

	// New scroll callback to toggle the "is-scrolled-down" class based on scroll position
	lenis.on("scroll", (e) => {
		// Use the scroll value provided by Lenis or fallback to window.pageYOffset
		const scrollY = e.scroll || window.pageYOffset;
		if (scrollY > 150) {
			document.body.classList.add("is-scrolled-down");
		} else {
			document.body.classList.remove("is-scrolled-down");
		}

		$(".c-header_wrap").removeClass("-navopen");
	});

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000);
	});

	gsap.ticker.lagSmoothing(0);

	// Smooth scroll on anchor click
	document.querySelectorAll("a").forEach((anchor) => {
		anchor.addEventListener("click", (event) => {
			const href = anchor.getAttribute("href");
			const header = document.querySelector(".c-header");

			// If href is empty or points to a different website, ignore it
			if (!href || (href.indexOf(window.location.origin) !== 0 && !href.startsWith("#"))) {
				return;
			}

			// Extract the target ID
			let targetId = href.split("#")[1];
			const headerHeight = header.offsetHeight;

			if (!targetId) {
				return; // If there's no hash part, do nothing
			}

			// Find the target element by ID
			const targetElement = document.getElementById(targetId);

			if (targetElement) {
				lenis.start();

				lenis.scrollTo(targetElement, {
					offset: -headerHeight,
				});
				// Prevent the default anchor behavior
				event.preventDefault();
			}
		});
	});

	return lenis;
}

jQuery(function ($) {
	//Scroll - Anchors
	var lenis = initLenis();

	$(".o-carousel").each(function () {
		$(this).flickity({
			cellAlign: "center",
			wrapAround: true,
			autoPlay: true,
			pageDots: false,
			prevNextButtons: false,
			adaptiveHeight: true,
		});
	});

	$(".c-headerTrigger").on("click touch", function () {
		$(".c-header_wrap").toggleClass("-navopen");
	});

	// Smooth scroll on anchor click
	document.querySelectorAll("a").forEach((anchor) => {
		anchor.addEventListener("click", (event) => {
			const href = anchor.getAttribute("href");
			const header = document.querySelector(".c-header");

			// If href is empty or points to a different website, ignore it
			if (!href || (href.indexOf(window.location.origin) !== 0 && !href.startsWith("#"))) {
				return;
			}

			// Extract the target ID
			let targetId = href.split("#")[1];
			const headerHeight = header.offsetHeight;

			if (!targetId) {
				return; // If there's no hash part, do nothing
			}

			// Find the target element by ID
			const targetElement = document.getElementById(targetId);

			if (targetElement) {
				lenis.start();

				lenis.scrollTo(targetElement, {
					offset: -headerHeight,
				});
				// Prevent the default anchor behavior
				event.preventDefault();
			}
		});
	});
});
